import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../pages/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleLogoClick = () => {
    navigate('/');
  };

  // 检查当前是否在首页
  const isHomePage = location.pathname === '/' || location.pathname.startsWith('/video/');

  return (
    <nav className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div onClick={handleLogoClick} className="cursor-pointer">
              <svg className="w-8 h-8 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A2.72 2.72 0 001 8.7c0 2.43 0 7.51 0 9.94a2.72 2.72 0 001.54 2.29 2.78 2.78 0 001.94 2C5.12 21.4 12 21.4 12 21.4s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 2.72 2.72 0 001.54-2.3c0-2.43 0-7.5 0-9.94a2.72 2.72 0 00-1.54-2.29z"></path>
                <path d="M9.75 15.02A1.25 1.25 0 118.5 13.77a1.25 1.25 0 011.25 1.25zm5.5 0a1.25 1.25 0 11-1.25-1.25 1.25 1.25 0 011.25 1.25zm1.5-6.77h-7a1 1 0 00-1 1v1a1 1 0 001 1h7a1 1 0 001-1v-1a1 1 0 00-1-1z"></path>
              </svg>
            </div>
            <span onClick={handleLogoClick} className="font-bold text-xl text-blue-500 cursor-pointer">DutliDutli</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-6 flex-1 mx-10">
            <Link to="/" className="text-blue-500 font-medium">首页</Link>
            <Link to="/anime" className="text-gray-600 hover:text-blue-500">动画</Link>
            <Link to="/bangumi" className="text-gray-600 hover:text-blue-500">番剧</Link>
            <Link to="/guochuang" className="text-gray-600 hover:text-blue-500">国创</Link>
            <Link to="/music" className="text-gray-600 hover:text-blue-500">音乐</Link>
            <Link to="/dance" className="text-gray-600 hover:text-blue-500">舞蹈</Link>
            {user && (
              <Link to="/profile" className="text-gray-600 hover:text-blue-500">个人空间</Link>
            )}
          </div>
          
          <div className="flex items-center space-x-4">
            {!isHomePage && (
              <Link 
                to="/" 
                className="hidden md:flex items-center text-gray-600 hover:text-blue-500 text-sm"
              >
                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                返回首页
              </Link>
            )}
            <input 
              type="text" 
              placeholder="搜索..."
              className="hidden md:block px-3 py-1 border border-gray-300 rounded-full text-sm"
            />
            {user ? (
              <div className="flex items-center space-x-4">
                <Link 
                  to="/profile" 
                  className="flex items-center text-gray-700 hover:text-blue-500"
                >
                  {user.avatar ? (
                    <img 
                      src={user.avatar} 
                      alt={user.username}
                      className="w-8 h-8 rounded-full mr-2 object-cover"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'block';
                      }}
                    />
                  ) : null}
                  <div className="w-8 h-8 rounded-full mr-2 flex items-center justify-center bg-gray-200" 
                       style={{ display: user.avatar ? 'none' : 'flex' }}>
                    <svg className="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd"></path>
                    </svg>
                  </div>
                  <span>{user.username}</span>
                </Link>
                <button 
                  onClick={handleLogout}
                  className="text-gray-600 hover:text-blue-500"
                >
                  退出
                </button>
              </div>
            ) : (
              <>
                <Link 
                  to="/login"
                  className="text-blue-500 hover:text-blue-600"
                >
                  登录
                </Link>
                <Link 
                  to="/register"
                  className="hidden md:inline text-gray-600 hover:text-blue-500"
                >
                  注册
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}